import {SearchResult} from '../../components/search';

export default SearchResult;